@if (showLdr) {
<ds-loading></ds-loading>
}
<div class="vehDsbrd vehicle-slider-shell">
  <!-- Vehicle Details Card -->
  <section class="widget-card vehicle-card">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h2>
        <span>Vehicle Details</span><span>&nbsp;({{ currentFrmtDate }})</span>
      </h2>
      <div class="info-row">
        <div class="info-label">
          <h3>Vehicle Registration Number</h3>
        </div>
        <div class="info-separator">:</div>
        <div class="info-value fw-600">
          <h4 class="value-emphasis">
            {{ vehnm == null ? "NA" : vehnm }}
            @if (VhcleDetails?.asrt_ownr_id == 1) {
            <span
              style="
                margin-left: 6px;
                padding: 2px 8px;
                font-size: 10px;
                font-weight: 600;
                border-radius: 4px;
                background-color: #dbeafe;
                color: #1d4ed8;
              "
              >Own Vehicle</span
            >
            } @if (VhcleDetails?.asrt_ownr_id == 2) {
            <span
              style="
                margin-left: 6px;
                padding: 2px 8px;
                font-size: 10px;
                font-weight: 600;
                border-radius: 4px;
                background-color: #fef3c7;
                color: #b45309;
              "
              >Hired Vehicle</span
            >
            }
          </h4>
        </div>
      </div>
      <div class="info-row">
        <div class="info-label">
          <h3>IMEI Number</h3>
        </div>
        <div class="info-separator">:</div>
        <div class="info-value">
          <h4>
            {{
              VhcleDetails.dev_imei_nu == null ? "" : VhcleDetails.dev_imei_nu
            }}
          </h4>
        </div>
      </div>
      @if (userDtls?.rle_id!=4000001) {
      <div class="veList" [class.expanded]="vehicleCardExpanded">
        <!-- First 4 rows (always visible) -->
        <div class="info-row">
          <div class="info-label">
            <h3>Vehicle Status</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{ asrt_sts_nm == null ? "NA" : asrt_sts_nm }}</h4>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Distance Travelled</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{ CrntDyDst == null ? "0" : CrntDyDst }} Kms</h4>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Ignition</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{ VhcleDetails.igntn_in == 1 ? "On" : "Off" }}</h4>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Start Location</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{ VhcleDetails.startFence || "NA" }}</h4>
          </div>
        </div>
        <!-- Additional rows (shown when expanded) -->
        @if (vehicleCardExpanded) {
        <div class="additional-rows">
          @if (clntDtls && clntDtls[0].clnt_id==7) {
          <div class="info-row">
            <div class="info-label">
              <h3>Sachivalayam</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              @if (VhcleDetails) {
              <h4>
                {{
                  VhcleDetails.svm_nm == null
                    ? "Sachivalayam not
                      assigned"
                    : VhcleDetails.svm_nm
                }}
              </h4>
              }
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">
              <h3>Secratory</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              @if (VhcleDetails) {
              <h4>
                {{
                  VhcleDetails.ss_nm == null
                    ? "Secratory not assigned"
                    : VhcleDetails.ss_nm
                }}
                @if (VhcleDetails.ss_cntct) {
                <span>
                  -
                  {{
                    VhcleDetails.ss_cntct == null ? "" : VhcleDetails.ss_cntct
                  }}</span
                >
                }
              </h4>
              }
            </div>
          </div>
          }
          <div class="info-row">
            <div class="info-label">
              <h3>Device Odometer Reading</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>{{ devOdmtr == null ? 0 : devOdmtr }} km</h4>
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">
              <h3>Chasis Number</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  VhcleDetails.asrt_chses_nu == null
                    ? "Not provided"
                    : VhcleDetails.asrt_chses_nu
                }}
              </h4>
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">
              <h3>Speed</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>{{ speed == null ? 0 : speed }} km/Hr</h4>
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">
              <h3>Coverage%</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  VhcleDetails.coverage_per === null
                    ? 0
                    : VhcleDetails.coverage_per
                }}
                %
              </h4>
            </div>
          </div>
          <div class="info-row">
            <div class="info-label">
              <h3>Data Last Received on</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  data_lst_rcvd == null
                    ? ""
                    : (data_lst_rcvd | date : "dd-MM-yyyy HH:mm:ss")
                }}
              </h4>
            </div>
          </div>
        </div>
        }
        <!-- Show More/Less Button -->
        <div class="trip-toggle-container">
          <span class="trip-toggle-link" (click)="toggleVehicleCard()">
            {{ vehicleCardExpanded ? "Show Less" : "Show More" }}
            <i
              nz-icon
              [nzType]="vehicleCardExpanded ? 'up' : 'down'"
              nzTheme="outline"
            ></i>
          </span>
        </div>
      </div>
      }
    </div>
  </section>

  <!-- Driver Details Card -->
  <section class="widget-card driver-card">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h2>Driver Details</h2>
      <div class="veList">
        @if (VhcleDetails.crw_img_url && VhcleDetails.crw_img_url !=
        'undefined') {
        <div class="driver-photo">
          <img [src]="VhcleDetails.crw_img_url" alt="Driver" />
        </div>
        }
        <div class="info-row">
          <div class="info-label">
            <h3>Driver Name</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            @if (VhcleDetails) {
            <h4>
              @if (VhcleDetails.crw_nm === null) {
              <span>Driver not assigned</span>
              } @if (VhcleDetails.crw_nm !== null) {
              <span>
                {{ VhcleDetails.crw_nm }}
                @if (VhcleDetails.crw_own_in == 1) {
                <span
                  style="
                    margin-left: 6px;
                    padding: 2px 8px;
                    font-size: 10px;
                    font-weight: 600;
                    border-radius: 4px;
                    background-color: #dbeafe;
                    color: #1d4ed8;
                  "
                  >Own Driver</span
                >
                } @if (VhcleDetails.crw_own_in == 2) {
                <span
                  style="
                    margin-left: 6px;
                    padding: 2px 8px;
                    font-size: 10px;
                    font-weight: 600;
                    border-radius: 4px;
                    background-color: #fef3c7;
                    color: #b45309;
                  "
                  >Hired Driver</span
                >
                }
              </span>
              }
            </h4>
            }
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Driver Phone Number</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            @if (VhcleDetails) {
            <h4>
              {{
                VhcleDetails.crw_ph === null
                  ? "Driver not assigned"
                  : VhcleDetails.crw_ph
              }}
            </h4>
            }
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Driver License Number</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            @if (VhcleDetails) {
            <h4>
              {{
                VhcleDetails.crw_lcnse_nu === null
                  ? "NA"
                  : VhcleDetails.crw_lcnse_nu
              }}
            </h4>
            }
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Driver DOJ</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            @if (VhcleDetails) {
            <h4>
              {{ VhcleDetails.crw_doj === null ? "NA" : VhcleDetails.crw_doj }}
            </h4>
            }
          </div>
        </div>
        <!-- <div class="info-row current-location-row">
        <div class="info-label">
          <h3>Current Location <span><button class="location-icon"
            *ngIf="VhcleDetails.lat && VhcleDetails.lng" (click)="showOnMap()" type="button"
            aria-label="View on map">
            <i nz-icon nzType="environment" nzTheme="outline"></i>
          </button></span></h3>
        </div>
        <div class="info-separator">:</div>
        <div class="info-value location-data-wrapper">
          <span class="location-text">{{VhcleDetails.curr_loc ||'NA'}}</span>
        </div>
      </div> -->
      </div>
    </div>
  </section>

  <!-- Location details -->
  <section class="widget-card location-card">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h2><span>Location Details</span></h2>
      <div class="veList">
        <div class="info-row">
          <div class="info-label">
            <h3>Current Location</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value location-value">
            @if (VhcleDetails) {
            <h4>{{ VhcleDetails.curr_loc || "NA" }}</h4>
            } @if (VhcleDetails.lat && VhcleDetails.lng) {
            <i
              nz-icon
              nzType="environment"
              nzTheme="outline"
              (click)="showOnMap()"
              title="View on Map"
              class="location-map-icon"
            ></i>
            }
          </div>
        </div>
        <!-- <div class="info-row" *ngIf="VhcleDetails.startFence">
      <div class="info-label">
        <h3>Start Location</h3>
      </div>
      <div class="info-separator">:</div>
      <div class="info-value">
        <h4>{{VhcleDetails.startFence || 'NA'}}</h4>
      </div>
    </div>
    <div class="info-row" *ngIf="VhcleDetails.endFence">
      <div class="info-label">
        <h3>End Location</h3>
      </div>
      <div class="info-separator">:</div>
      <div class="info-value">
        <h4>{{VhcleDetails.endFence || 'NA'}}</h4>
      </div>
    </div>
    <div class="info-row" *ngIf="VhcleDetails.lat && VhcleDetails.lng">
      <div class="info-label">
        <h3>Latitude</h3>
      </div>
      <div class="info-separator">:</div>
      <div class="info-value">
        <h4>{{VhcleDetails.lat | number:'1.6-6'}}</h4>
      </div>
    </div>
    <div class="info-row" *ngIf="VhcleDetails.lat && VhcleDetails.lng">
      <div class="info-label">
        <h3>Longitude</h3>
      </div>
      <div class="info-separator">:</div>
      <div class="info-value">
        <h4>{{VhcleDetails.lng | number:'1.6-6'}}</h4>
      </div>
    </div> -->
      </div>
    </div>
  </section>

  <!-- Current Trip Running Status -->
  <section class="widget-card driver-card">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h2>Trips</h2>

      <!-- Show running trip or first trip (collapsible) -->
      @if (currentTripStatus && !allTripsCompleted) {
      <div class="veList trip-list-container">
        <!-- First trip card (always visible) -->
        <div
          class="trip-card-single"
          [class.expanded]="showTripDetails || allTripsData.length === 1"
        >
          <div class="info-row">
            <div class="info-label">
              <h3>Trip Status</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4
                [class.trip-running]="
                  currentTripStatus.TripStatus === 'Running' ||
                  currentTripStatus.trp_status === 'Running'
                "
                [class.trip-completed]="
                  currentTripStatus.TripStatus === 'Completed' ||
                  currentTripStatus.trp_status === 'Completed'
                "
                [class.trip-not-started]="
                  currentTripStatus.TripStatus === 'Not Started' ||
                  currentTripStatus.trp_status === 'Not Started'
                "
              >
                {{
                  currentTripStatus.TripStatus ||
                    currentTripStatus.trp_status ||
                    "NA"
                }}
              </h4>
            </div>
          </div>
          @if (currentTripStatus.TRIP_NUM || currentTripStatus.trp_sqnce_nu) {
          <div class="info-row">
            <div class="info-label">
              <h3>Trip Number</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  currentTripStatus.TRIP_NUM ||
                    currentTripStatus.trp_sqnce_nu ||
                    "NA"
                }}
              </h4>
            </div>
          </div>
          } @if (currentTripStatus.SOURCE || currentTripStatus.src_loc) {
          <div class="info-row">
            <div class="info-label">
              <h3>Source Location</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  currentTripStatus.SOURCE || currentTripStatus.src_loc || "NA"
                }}
              </h4>
            </div>
          </div>
          } @if (currentTripStatus.DESTINATION || currentTripStatus.dest_loc) {
          <div class="info-row">
            <div class="info-label">
              <h3>Destination Location</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  currentTripStatus.DESTINATION ||
                    currentTripStatus.dest_loc ||
                    "NA"
                }}
              </h4>
            </div>
          </div>
          } @if (currentTripStatus.ACTUAL_START ||
          currentTripStatus.trp_strt_ts) {
          <div class="info-row">
            <div class="info-label">
              <h3>Start Time</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  currentTripStatus.ACTUAL_START ||
                    currentTripStatus.trp_strt_ts ||
                    "NA"
                }}
              </h4>
            </div>
          </div>
          } @if (currentTripStatus.ACTUAL_END || currentTripStatus.trp_end_ts) {
          <div class="info-row">
            <div class="info-label">
              <h3>End Time</h3>
            </div>
            <div class="info-separator">:</div>
            <div class="info-value">
              <h4>
                {{
                  currentTripStatus.ACTUAL_END ||
                    currentTripStatus.trp_end_ts ||
                    "NA"
                }}
              </h4>
            </div>
          </div>
          }
        </div>
        <!-- Show More/Less Button if there are other trips -->
        @if (allTripsData.length > 1) {
        <div class="trip-toggle-container">
          <span class="trip-toggle-link" (click)="toggleTripDetails()">
            {{ showTripDetails ? "Show Less" : "Show More" }} ({{
              allTripsData.length - 1
            }}
            more)
            <i
              nz-icon
              [nzType]="showTripDetails ? 'up' : 'down'"
              nzTheme="outline"
              style="margin-left: 4px"
            ></i>
          </span>
        </div>
        }
        <!-- Other trips (shown when expanded) -->
        @if (showTripDetails && allTripsData.length > 1) {
        <div class="other-trips-container">
          @for (trip of allTripsData; track trip; let i = $index) {
          <div
            class="trip-card"
            [style.display]="trip === currentTripStatus ? 'none' : 'block'"
          >
            <div class="trip-card-header">
              <h4>
                Trip {{ i + 1 }}:
                {{ trip.TRIP_NUM || trip.trp_sqnce_nu || "N/A" }}
              </h4>
              <span
                class="trip-status-badge"
                [class.trip-running]="
                  trip.TripStatus === 'Running' || trip.trp_status === 'Running'
                "
                [class.trip-completed]="
                  trip.TripStatus === 'Completed' ||
                  trip.trp_status === 'Completed'
                "
              >
                {{ trip.TripStatus || trip.trp_status || "NA" }}
              </span>
            </div>
            <div class="trip-card-body">
              <div class="info-row">
                <div class="info-label">
                  <h3>Source</h3>
                </div>
                <div class="info-separator">:</div>
                <div class="info-value">
                  <h4>{{ trip.SOURCE || trip.src_loc || "NA" }}</h4>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <h3>Destination</h3>
                </div>
                <div class="info-separator">:</div>
                <div class="info-value">
                  <h4>{{ trip.DESTINATION || trip.dest_loc || "NA" }}</h4>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">
                  <h3>Start Time</h3>
                </div>
                <div class="info-separator">:</div>
                <div class="info-value">
                  <h4>{{ trip.ACTUAL_START || trip.trp_strt_ts || "NA" }}</h4>
                </div>
              </div>
              @if (trip.ACTUAL_END || trip.trp_end_ts) {
              <div class="info-row">
                <div class="info-label">
                  <h3>End Time</h3>
                </div>
                <div class="info-separator">:</div>
                <div class="info-value">
                  <h4>{{ trip.ACTUAL_END || trip.trp_end_ts || "NA" }}</h4>
                </div>
              </div>
              } @if (trip.actl_trvl_dstne_ct !== null && trip.actl_trvl_dstne_ct
              !== undefined) {
              <div class="info-row">
                <div class="info-label">
                  <h3>Distance</h3>
                </div>
                <div class="info-separator">:</div>
                <div class="info-value">
                  <h4>{{ trip.actl_trvl_dstne_ct || 0 }} Kms</h4>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
        }
      </div>
      }

      <!-- Show all trips as cards if all completed -->
      @if (allTripsCompleted && allTripsData.length > 0) {
      <div class="veList">
        <div class="info-row">
          <div class="info-value" style="width: 100%; text-align: center">
            <h4 class="trip-completed">
              All Trips Completed ({{ allTripsData.length }})
            </h4>
          </div>
        </div>
        <!-- Show each trip as a card -->
        @for (trip of allTripsData; track trip; let i = $index) {
        <div class="trip-card">
          <div class="trip-card-header">
            <h4>
              Trip {{ i + 1 }}:
              {{ trip.TRIP_NUM || trip.trp_sqnce_nu || "N/A" }}
            </h4>
            <span
              class="trip-status-badge"
              [class.trip-completed]="
                trip.TripStatus === 'Completed' ||
                trip.trp_status === 'Completed'
              "
            >
              {{ trip.TripStatus || trip.trp_status || "NA" }}
            </span>
          </div>
          <div class="trip-card-body">
            <div class="info-row">
              <div class="info-label">
                <h3>Source</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ trip.SOURCE || trip.src_loc || "NA" }}</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Destination</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ trip.DESTINATION || trip.dest_loc || "NA" }}</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>Start Time</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ trip.ACTUAL_START || trip.trp_strt_ts || "NA" }}</h4>
              </div>
            </div>
            <div class="info-row">
              <div class="info-label">
                <h3>End Time</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ trip.ACTUAL_END || trip.trp_end_ts || "NA" }}</h4>
              </div>
            </div>
            @if (trip.actl_trvl_dstne_ct !== null && trip.actl_trvl_dstne_ct !==
            undefined) {
            <div class="info-row">
              <div class="info-label">
                <h3>Distance</h3>
              </div>
              <div class="info-separator">:</div>
              <div class="info-value">
                <h4>{{ trip.actl_trvl_dstne_ct || 0 }} Kms</h4>
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }

      <!-- Show other trips when details button is clicked -->
      <!-- <div class="veList" *ngIf="showTripDetails && !allTripsCompleted && allTripsData.length > 1">
    <div class="info-row" style="border-top: 2px solid rgba(148, 163, 184, 0.2); margin-top: 8px; padding-top: 8px;">
      <div class="info-value" style="width: 100%;">
        <h3 style="font-weight: 600; margin-bottom: 8px;">Other Trips:</h3>
      </div>
    </div>
    <div class="trip-card" *ngFor="let trip of allTripsData; let i = index"
      [style.display]="trip === currentTripStatus ? 'none' : 'block'">
      <div class="trip-card-header">
        <h4>Trip {{i + 1}}: {{trip.TRIP_NUM || trip.trp_sqnce_nu || 'N/A'}}</h4>
        <span class="trip-status-badge"
          [class.trip-running]="trip.TripStatus === 'Running' || trip.trp_status === 'Running'"
          [class.trip-completed]="trip.TripStatus === 'Completed' || trip.trp_status === 'Completed'">
          {{trip.TripStatus || trip.trp_status || 'NA'}}
        </span>
      </div>
      <div class="trip-card-body">
        <div class="info-row">
          <div class="info-label">
            <h3>Source</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{trip.SOURCE || trip.src_loc || 'NA'}}</h4>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Destination</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{trip.DESTINATION || trip.dest_loc || 'NA'}}</h4>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <h3>Start Time</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{trip.ACTUAL_START || trip.trp_strt_ts || 'NA'}}</h4>
          </div>
        </div>
        <div class="info-row" *ngIf="trip.ACTUAL_END || trip.trp_end_ts">
          <div class="info-label">
            <h3>End Time</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{trip.ACTUAL_END || trip.trp_end_ts || 'NA'}}</h4>
          </div>
        </div>
        <div class="info-row" *ngIf="trip.actl_trvl_dstne_ct !== null && trip.actl_trvl_dstne_ct !== undefined">
          <div class="info-label">
            <h3>Distance</h3>
          </div>
          <div class="info-separator">:</div>
          <div class="info-value">
            <h4>{{trip.actl_trvl_dstne_ct || 0}} Kms</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->
      @if (!currentTripStatus && !loadingCurrentTrip && allTripsData.length ===
      0) {
      <div class="veList">
        <div class="info-row">
          <div class="info-value" style="text-align: center; width: 100%">
            <h4>No trip found</h4>
          </div>
        </div>
      </div>
      } @if (loadingCurrentTrip) {
      <div class="veList">
        <div class="info-row">
          <div class="info-value" style="text-align: center; width: 100%">
            <h4>Loading trip status...</h4>
          </div>
        </div>
      </div>
      }
    </div>
  </section>
  <!-- ---------------------------------------------------------------------------------------- -->

  <!-- ----------------------------------Trips details------------------------------------------- -->
  <!-- <section class="widget-card accordion-section">
<div class="accordion-header" (click)="toggleSection('trips')">
  <h1>Trips Coverage Of Vehicle</h1>
  <span class="accordion-icon" [class.expanded]="expandedSections.trips">{{expandedSections.trips ? '▼' :
  '▶'}}</span>
</div>
<div class="accordion-content" *ngIf="expandedSections.trips">
  <div class="col-lg-12 col-md-12 w-100 crd bxshw_n">
    <div *ngIf="tripsData && tripsData.length>0" class="cstm_tbl-wrapper">
      <table class="cstm_tbl">
        <thead>
          <tr>
            <th>sno</th>
            <th>ULB</th>
            <th *ngIf="clntDtls[0]?.clnt_id==3000001">Zone</th>
            <th>Vehicle</th>
            <th>Trip Number</th>
            <th>Source</th>
            <th>Destination</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Travelled Distance (In KM)</th>
            <th>Trip Status</th>
            <th>Route Deviated</th>
            <th>Playback</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of tripsData">
            <td>{{t.sno}}</td>
            <td>{{t.ZONE}}</td>
            <td *ngIf="clntDtls[0]?.clnt_id==3000001">{{t.asrt_grp_nm}}</td>
            <td>{{t.VEHICLE}}</td>
            <td>{{t.TRIP_NUM}}</td>
            <td>{{t.SOURCE}}</td>
            <td>{{t.DESTINATION}}</td>
            <td>{{t.ACTUAL_START}}</td>
            <td>{{t.ACTUAL_END}}</td>
            <td>{{t.actl_trvl_dstne_ct}}</td>
            <td>{{t.TripStatus}}</td>
            <td>{{t.Deviation}}</td>
            <td (click)="goToPlayback(t)" style="color: #009688;cursor: pointer;"> <i nz-icon
            nzType="node-index" nzTheme="outline"></i>
          Playback</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row NtfctnCrd" *ngIf="tripsData && tripsData.length == 0">
    <h5 style="text-align: center;">No trips found for this vehicle</h5>
  </div>
</div>
</div>
</section> -->
  <!-- ----------------------------------Trips details------------------------------------------- -->

  <!-- <section class="widget-card accordion-section">
<div class="accordion-header" (click)="toggleSection('operational')">
  <h1>Operational Details - Today ({{currentFrmtDate}})</h1>
  <span class="accordion-icon" [class.expanded]="expandedSections.operational">{{expandedSections.operational
  ? '▼' : '▶'}}</span>
</div>
<div class="accordion-content" *ngIf="expandedSections.operational">
  <div class="col-lg-12 col-md-12 w-100 crd bxshw_n">
    <div *ngIf="oprtnlhrs && oprtnlhrs.length>0" class="operational-card">
      <div class="operational-card-item" *ngFor="let o of oprtnlhrs">
        <div class="card-item-row">
          <div class="card-item-label">Date:</div>
          <div class="card-item-value">{{o.dt}}</div>
        </div>
        <div class="card-item-row">
          <div class="card-item-label">Vehicle No.:</div>
          <div class="card-item-value">{{o.asrt_nm}}</div>
        </div>
        <div class="card-item-row">
          <div class="card-item-label">Vehicle Category:</div>
          <div class="card-item-value">{{o.asrt_ctgry_nm}}</div>
        </div>
        <div class="card-item-row">
          <div class="card-item-label">Operational Hours:</div>
          <div class="card-item-value">{{o.oprtn_hrs_ct}}</div>
        </div>
        <div class="card-item-row">
          <div class="card-item-label">Travelled (km):</div>
          <div class="card-item-value">{{o.dst}}</div>
        </div>
        <div class="card-item-row">
          <div class="card-item-label">Status:</div>
          <div class="card-item-value" [ngClass]="{'status-operated': o.operated == 1, 'status-not-operated': o.operated == 0}">
            <span *ngIf="o.operated == 1">Operated</span>
            <span *ngIf="o.operated == 0">Not-Operated</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row NtfctnCrd" *ngIf="oprtnlhrsMsg">
      <h5 style="text-align: center;">{{oprtnlhrsMsg}}</h5>
    </div>
  </div>
</div>
</section>

<section class="widget-card accordion-section">
  <div class="accordion-header" (click)="toggleSection('speedViolation')">
    <h1>Last 7Days Speed Violation</h1>
    <span class="accordion-icon"
      [class.expanded]="expandedSections.speedViolation">{{expandedSections.speedViolation ? '▼' :
    '▶'}}</span>
  </div>
  <div class="accordion-content" *ngIf="expandedSections.speedViolation">
    <div class="col-lg-12 col-md-12 w-100 crd bxshw_n">
      <div class="row" *ngIf="ovrSpeed && ovrSpeed.length>0">
        <div class="cstm_tbl-wrapper">
          <table class="cstm_tbl">
            <thead>
              <tr>
                <th>Recorded Date</th>
                <th>Vehicle No.</th>
                <th>Vehicle Category</th>
                <th>Speed(km)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of ovrSpeed">
                <td>{{t.dt}}</td>
                <td>{{t.asrt_nm}}</td>
                <td>{{t.asrt_ctgry_nm}}</td>
                <td>{{t.speed}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row NtfctnCrd" *ngIf="ovrSpeedMsg">
        <h5 style="text-align: center;">{{ovrSpeedMsg}}</h5>
      </div>
    </div>
  </div>
</section>

<section class="widget-card accordion-section">
  <div class="accordion-header" (click)="toggleSection('tripsList')">
    <h1>Last 7Days Trips List <b *ngIf="eachVeh && eachVeh.length">{{VhcleDetails.asrt_nm}}</b></h1>
    <span class="accordion-icon" [class.expanded]="expandedSections.tripsList">{{expandedSections.tripsList ?
    '▼' : '▶'}}</span>
  </div>
  <div class="accordion-content" *ngIf="expandedSections.tripsList">
    <div class="col-lg-12 col-md-12 w-100 crd bxshw_n">
      <div *ngIf="eachVeh && eachVeh.length>0" class="cstm_tbl-wrapper">
        <table class="cstm_tbl">
          <thead>
            <tr>
              <th>Date</th>
              <th>No. of Trips</th>
              <th>Driver</th>
              <th>Travelled(km)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of eachVeh">
              <td>{{o.dt}}-{{curYr}}</td>
              <td>{{o.trp_cnt}}</td>
              <td>{{o.crw_nm ? o.crw_nm : 'Driver not Assigned'}}</td>
              <td>{{o.trp_dst}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row NtfctnCrd" *ngIf="tripsMsg">
        <h5 style="text-align: center;">{{tripsMsg}}</h5>
      </div>
    </div>
  </div>
</section> -->
  <!-- ---------------------------------------------------------------------------------------- -->
</div>
